import moment from "moment";

function getFirstUpcomingActiveDate(activeDates: string[], today: Date = new Date()): Date | null {
    const startOfToday = moment(today).startOf("day");
    const upcomingDates = activeDates
        .map((activeDate) => moment(activeDate, moment.ISO_8601, true))
        .filter((activeDate) => activeDate.isValid())
        .map((activeDate) => activeDate.startOf("day"))
        .filter((activeDate) => !activeDate.isBefore(startOfToday))
        .sort((leftDate, rightDate) => leftDate.diff(rightDate));

    return upcomingDates[0]?.toDate() ?? null;
}

export { getFirstUpcomingActiveDate };
